var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftSwoosh = function SvgLeftSwoosh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 258,
    fill: "none",
    viewBox: "0 0 140 258"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M125 123C81 123 14 97 0 0v258h140V123z"
  })));
};
export { SvgLeftSwoosh as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQwIiBoZWlnaHQ9IjI1OCIgdmlld0JveD0iMCAwIDE0MCAyNTgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZD0iTTEyNSAxMjNDODEgMTIzIDE0IDk3IDAgMHYyNThoMTQwVjEyM2gtMTV6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+";